import styled from "styled-components";
import TextProps from "./Text.types";

export const StyledText = styled.div<TextProps>`
    font-size: ${(props) => props.theme.typography.sizes[props.size as keyof TextProps["size"]]};
    font-weight: ${(props) => props.theme.typography.weights[props.weight as keyof TextProps["weight"]]};
    color: ${(props) => props.theme.colors[props.color as keyof TextProps["color"]]};
`;
